import React from "react";
import Table from "../../../components/Table";
import { OverigeFinancieelPost } from "../../../../../.generated/rapportage/rapportagetypes";
import { getOverigeFinancielePostenColumns } from "../../Producten/overige-financiele-posten-kolommen";

export interface SingleOverigeFinancielePostenTableProps {
  data: OverigeFinancieelPost;
}

export interface OverigeFinancielePostenTableProps {
  data: OverigeFinancieelPost[];
}

export const SingleOverigeFinancielePostenTable: React.FC<SingleOverigeFinancielePostenTableProps> = ({
  data,
}: SingleOverigeFinancielePostenTableProps) => {
  return (
    <div className="mb-4">
      <Table
        columns={getOverigeFinancielePostenColumns(true)}
        data={[data]}
        rotate={true}
        showHeader={true}
        filterNullAnd0Columns={true}
        id={`overige-financiele-posten-table-${data.omschrijving
          ?.replace(/\s+/g, "-")
          .toLowerCase() || "overige-financiele-posten"}`}
      />
    </div>
  );
};

export const OverigeFinancielePostenTable: React.FC<OverigeFinancielePostenTableProps> = ({
  data,
}: OverigeFinancielePostenTableProps) => {
  return (
    <div className="overige-financiele-posten-section">
      {data.map((post, index) => (
        <SingleOverigeFinancielePostenTable key={index} data={post} />
      ))}
    </div>
  );
};
